function stringLiteralArray(a) {
    return a;
}
export const animatableProperties = stringLiteralArray([
    'x',
    'y',
    'originX',
    'originY',
    'rotationX',
    'rotationY',
    'rotationZ',
    'opacity',
    'scaleX',
    'scaleY',
    'fill',
    'radius',
    'shadows',
    'filters',
    'textColor',
    'border'
]);
export const transitionSettingPropertyToUnitMap = {
    direction: 'angle',
    distance: 'number'
};
